function normalizarSexo(sexo) {
  if (sexo == null) return undefined;
  if (typeof sexo === "string") return sexo;
  if (typeof sexo === "object" && sexo.codigo != null) return sexo.codigo;
  return undefined;
}

function apenasDigitosCep(cep) {
  if (cep == null) return "";
  return String(cep).replace(/\D/g, "");
}

function apenasDigitosCpf(cpf) {
  if (cpf == null) return null;
  const d = String(cpf).replace(/\D/g, "");
  return d || null;
}

function passaporteNormalizado(passaporte) {
  if (passaporte == null) return undefined;
  const t = String(passaporte).trim();
  return t ? t.toUpperCase() : undefined;
}

function mapEndereco(endereco) {
  if (!endereco) return undefined;
  const siglaPais =
    endereco.pais && endereco.pais.sigla != null
      ? endereco.pais.sigla
      : endereco.siglaPais;
  const idMunicipio =
    endereco.municipio && endereco.municipio.id != null
      ? endereco.municipio.id
      : endereco.idMunicipio;

  return {
    logradouro: endereco.logradouro,
    numero: endereco.numero,
    complemento: endereco.complemento,
    bairro: endereco.bairro,
    cep: apenasDigitosCep(endereco.cep),
    idMunicipio: idMunicipio != null ? idMunicipio : null,
    siglaPais,
    municipioInternacional: endereco.municipioInternacional,
    estadoInternacional: endereco.estadoInternacional,
    descricao: endereco.descricao
  };
}

function mapPessoaFisica(pf) {
  if (!pf) return undefined;
  const siglaPais =
    pf.pais && pf.pais.sigla != null ? pf.pais.sigla : pf.siglaPais;

  return {
    nome: pf.nome,
    cpf: apenasDigitosCpf(pf.cpf),
    passaporte: passaporteNormalizado(pf.passaporte),
    dataNascimento: pf.dataNascimento,
    nomeMae: pf.nomeMae,
    sexo: normalizarSexo(pf.sexo),
    siglaPais
  };
}

export function mapPessoaPerfilParaPessoaCreate(pessoa) {
  if (!pessoa) return null;
  return {
    email: pessoa.email,
    tipo: pessoa.tipo,
    pessoaFisica: mapPessoaFisica(pessoa.pessoaFisica),
    endereco: mapEndereco(pessoa.endereco)
  };
}
